import LayoutTradeAgreementsRegister from './LayoutTradeAgreementsRegister';
export default LayoutTradeAgreementsRegister;
